export const authUamErrorKinds = {
  accountNotFound: 'AUTH_UAM_ACCOUNT_NOT_FOUND',
  identityMismatch: 'AUTH_UAM_IDENTITY_MISMATCH',
  inviteMembershipNotReady: 'AUTH_UAM_INVITE_MEMBERSHIP_NOT_READY',
  membershipSyncFailed: 'AUTH_UAM_MEMBERSHIP_SYNC_FAILED',
  sessionExpired: 'AUTH_UAM_SESSION_EXPIRED',
} as const;

export type AuthUamErrorKind = (typeof authUamErrorKinds)[keyof typeof authUamErrorKinds];

export type AuthUamErrorDetails = {
  kind: AuthUamErrorKind;
  clerkOrganizationId?: string;
  error?: string;
  organisationId?: string;
  reason?: string;
  retryable?: boolean;
  source?: string;
};

export const isAuthUamErrorKind = (value: unknown): value is AuthUamErrorKind =>
  typeof value === 'string' && Object.values(authUamErrorKinds).includes(value as AuthUamErrorKind);

export const getAuthUamErrorKindFromDetails = (details: unknown): AuthUamErrorKind | null => {
  if (typeof details !== 'object' || details === null || !('kind' in details)) {
    return null;
  }
  return isAuthUamErrorKind(details.kind) ? details.kind : null;
};
